import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  avatarArea: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
    gap: "8px",
    padding: "16px 0px",
  },

  btnArea: {
    alignItems: "flex-start",
    display: "flex",
    gap: "8px",
    justifyContent: "flex-end",
    paddingTop: "12px",
  },

  clamp: {
    "-webkitLineClamp": 3,
  },

  container: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "row",
  },

  content: {
    alignItems: "flex-start",
    display: "flex",
    flex: "1 0 0",
    flexDirection: "column",
    justifyContent: "flex-end",
  },

  message: {
    "-webkitBoxOrient": "vertical",
    alignSelf: "stretch",
    color: colors.gray600,
    display: "-webkit-box",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.25px",
    lineHeight: "20px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },

  paragraph: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    justifyContent: "flex-end",
    padding: "8px 12px 16px 12px",
  },

  readMore: {
    color: colors.blue600,
    cursor: "pointer",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.25px",
    lineHeight: "20px",
  },

  timestamp: {
    color: colors.gray500,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    letterSpacing: "0.25px",
    lineHeight: "20px",
  },

  topCard: {
    alignItems: "flex-start",
    alignSelf: "stretch",
    display: "flex",
  },

  topCardHeader: {
    alignContent: "center",
    alignItems: "center",
    display: "flex",
    flex: "1 0 0",
    flexWrap: "wrap",
    gap: "4px 12px",
    padding: "16px 12px 0px 12px",
  },

  userAvatar: {
    borderRadius: "50%",
    height: "32px",
    objectFit: "cover",
    width: "32px",
  },

  userName: {
    color: colors.gray800,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 700,
    letterSpacing: "0.1px",
    lineHeight: "20px",
  },
  deleteButton: {
    position: "relative",
    left: "12px",
    top: "8px",
  },
}));

export default styles;
